export default "__VITE_ASSET__1co4Y8gN__"